import axios from 'axios';
import * as Sentry from "@sentry/browser";
import { livewire_hot_reload } from 'virtual:livewire-hot-reload'

window.axios = axios;
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
});

livewire_hot_reload();
